export const UI_STRINGS = {
  en: {
    nextQuestion: 'Next Question',
    submitSection: 'Submit Section',
    submitAssessment: 'Submit Assessment',
    sectionOf: 'Section {n} of 5',
    questionOf: 'Q {current} of {total}',
    translated: 'Translated',
    timeRemaining: 'Time Remaining',
    selectAnOption: 'Please select an option to continue.',
    sectionComplete: 'Section Complete',
    confirmSubmit: 'Submit Section & Continue',
    cancel: 'Cancel',
    assessmentRules: 'Assessment Rules',
    beginAssessment: 'I Understand - Begin Assessment'
  },
  hi: {
    nextQuestion: 'अगला प्रश्न',
    submitSection: 'अनुभाग जमा करें',
    submitAssessment: 'परीक्षा जमा करें',
    sectionOf: 'अनुभाग {n} / 5',
    questionOf: 'प्रश्न {current} / {total}',
    translated: 'अनुवादित',
    timeRemaining: 'शेष समय',
    selectAnOption: 'जारी रखने के लिए एक विकल्प चुनें।',
    sectionComplete: 'अनुभाग पूरा हुआ',
    confirmSubmit: 'अनुभाग जमा करें और आगे बढ़ें',
    cancel: 'रद्द करें',
    assessmentRules: 'परीक्षा नियम',
    beginAssessment: 'मैं समझता हूँ - परीक्षा शुरू करें'
  },
  ta: {
    nextQuestion: 'அடுத்த கேள்வி',
    submitSection: 'பிரிவை சமர்ப்பிக்கவும்',
    submitAssessment: 'தேர்வை சமர்ப்பிக்கவும்',
    sectionOf: 'பிரிவு {n} / 5',
    questionOf: 'கேள்வி {current} / {total}',
    translated: 'மொழிபெயர்க்கப்பட்டது',
    timeRemaining: 'மீதமுள்ள நேரம்',
    selectAnOption: 'தொடர ஒரு விருப்பத்தை தேர்ந்தெடுக்கவும்.',
    sectionComplete: 'பிரிவு முடிந்தது',
    confirmSubmit: 'பிரிவை சமர்ப்பித்து தொடரவும்',
    cancel: 'ரத்து செய்',
    assessmentRules: 'தேர்வு விதிகள்',
    beginAssessment: 'புரிகிறது - தேர்வை தொடங்கு'
  }
};

export function getUIString(lang, key, replacements = {}) {
  const strings = UI_STRINGS[lang] || UI_STRINGS.en;
  let str = strings[key] || UI_STRINGS.en[key] || key;
  Object.entries(replacements).forEach(([k, v]) => {
    str = str.replace(`{${k}}`, String(v));
  });
  return str;
}
